// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3OzEx","vLegacy":"SelectSecondary_vLegacy__PRhHP","error":"SelectSecondary_error__4_yGu","disabled":"SelectSecondary_disabled__1Erdc"};